<!-- 嵌入式-触发器设置 -->
<template>
  <div>
    <el-card>
      <div class="toolbar">
        <el-button size="small" type="primary" @click="showAddDialog"
          ><i class="fas fa-plus"></i> 新增触发器</el-button
        >
        <div class="pull-right search-area">
          <div class="box-inline" style="width: 200px; vertical-align: middle">
            <el-input
              class="pull-right"
              v-model="form['Name']"
              placeholder="名称"
              @keyup.enter.native="submitQuery"
            ></el-input>
          </div>
          &nbsp;
          <div class="box-inline" style="width: 200px; vertical-align: middle">
            <el-input
              class="pull-right"
              v-model="form['Keypath']"
              placeholder="数据路径查询"
              @keyup.enter.native="submitQuery"
            ></el-input>
          </div>
          &nbsp;
          <el-button
            size="small"
            class="pull-right"
            @click="onSubmitQuery"
            title="搜索"
          >
            <i class="fas fa-search"></i>
          </el-button>
        </div>
      </div>
      <el-table :data="triggerList" size="medium">
        <el-table-column
          type="index"
          :index="15 * (triggerPage - 1) + 1"
          width="52"
        ></el-table-column>
        <el-table-column label="触发器名称" prop="Name" min-width="110">
        </el-table-column>
        <el-table-column
          label="数据集名称"
          prop="Stream.Category.Name"
          min-width="110"
        >
        </el-table-column>
        <el-table-column label="数据流名称" prop="Stream.Name" min-width="110">
        </el-table-column>
        <el-table-column label="数据路径" prop="Keypath" min-width="95">
        </el-table-column>
        <el-table-column label="触发类型" prop="TypeName" min-width="95">
        </el-table-column>
        <el-table-column label="触发阈值" prop="Threshold" min-width="95">
        </el-table-column>
        <el-table-column label="通知方式" prop="InformName" min-width="95">
        </el-table-column>
        <el-table-column label="触发频率" prop="Frequency" min-width="95" />
        <el-table-column label="操作" width="150">
          <template scope="scope">
            <div>
              <el-button
                type="primary"
                size="small"
                @click="showEditDialog(scope.row)"
              >
                <i class="fas fa-edit"></i>
              </el-button>
              <el-button
                type="danger"
                size="small"
                @click="showDelete(scope.row.ID)"
              >
                <i class="fas fa-trash"></i>
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="clearfix mar-top">
        <el-pagination
          class="pull-right"
          @current-change="changeTriggerPage"
          layout="total, prev, pager, next"
          :total="triggerTotal"
          :current-page="triggerPage"
          :page-size="15"
        >
        </el-pagination>
      </div>
    </el-card>

    <el-dialog
      :visible="dialogVisible"
      :title="isEdit ? '修改触发器' : '新增触发器'"
      :close-on-click-modal="false"
      @close="cancel"
      :close-on-press-escape="false"
      width="45%"
      top="5%"
    >
      <el-form
        ref="triggerForm"
        :model="triggerForm"
        label-width="120px"
        :rules="triggerRule"
      >
        <el-form-item label="名称" prop="Name">
          <el-input v-model="triggerForm.Name"></el-input>
        </el-form-item>
        <el-form-item label="客户端范围" prop="Client">
          <el-select
            style="width: 150px"
            v-model="triggerForm.Client"
            @change="changeClient"
          >
            <el-option
              v-for="client in clientList"
              :label="client.Value"
              :value="client.Key"
              :key="client.Key"
            >
            </el-option>
          </el-select>
          &nbsp;
          <!-- 客户端范围（0：全应用，1：产品，2：标签，3：产品型号名称） -->
          <div class="box-inline">
            <select2
              ref="selProducts"
              v-if="triggerForm.Client === 1"
              style="width: 285px"
              labelName="SN"
              v-model="triggerForm.ClientProps.ID"
              url="dci/product/stock-list/list?order=-sn"
              :urlParams="{
                where: {},
              }"
              :multiple="true"
              clearable
              :collapse-tags="false"
              placeholder="请选择产品SN"
              no-data-text="无产品"
              q="SN:like"
              :qinwhere="true"
              :queryOne="false"
              :currentList="currentProducts"
            ></select2>
            <el-button
              v-if="triggerForm.Client === 1"
              type="success"
              @click="onChooseProductsClick"
              style="width: 76px"
            >
              <i class="fas fa-plus"></i> 选择产品
            </el-button>
            <el-select
              v-model="triggerForm.ClientProps.Tag"
              v-if="triggerForm.Client === 2"
              :multiple-limit="6"
              multiple
              filterable
              default-first-option
              placeholder="请选择标签"
              style="width: 285px"
            >
              <el-option
                v-for="(tag, index) in tagList"
                :key="index"
                :label="tag"
                :value="tag"
              ></el-option>
            </el-select>
            <el-select
              v-model="triggerForm.ClientProps.ModuleID"
              v-if="triggerForm.Client === 3"
              :multiple-limit="6"
              multiple
              filterable
              default-first-option
              placeholder="请选择产品型号名称"
              style="width: 285px"
            >
              <el-option
                v-for="model in modelList"
                :label="model.NameNumber"
                :value="model.ID"
                :key="model.ID"
              ></el-option>
            </el-select>
          </div>
        </el-form-item>
        <el-form-item
          label="数据路径"
          prop="Keypath"
          v-if="triggerForm.Type !== 11"
        >
          <!-- 触发类型不是掉线 -->
          <el-autocomplete
            ref="keypathInput"
            @change.native="triggerForm.Keypath = ''"
            custom-item="my-keypath-list"
            :trigger-on-focus="false"
            style="width: 100%"
            v-model="Keypath"
            :fetch-suggestions="queryKeypath"
            placeholder="输入关键字选择数据路径"
            @select="selectKeypath"
          ></el-autocomplete>
        </el-form-item>
        <el-form-item label="触发类型" prop="Type">
          <el-select
            style="width: 100%"
            v-model="triggerForm.Type"
            placeholder="请选择触发类型"
          >
            <el-option
              v-for="type in typeList"
              :label="type.Value"
              :value="type.Key"
              :key="type.Key"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 触发类型(1:>,2:>=,3:<,4:<=,5:=,6:!=,7:范围内,8:范围外,9:存在,10:不存在,11:掉线) -->
        <el-form-item
          prop="Threshold"
          label="触发阈值"
          v-if="!(triggerForm.Type === 9 || triggerForm.Type === 10)"
        >
          <div
            v-if="
              (triggerForm.Type === 7 || triggerForm.Type === 8) &&
              triggerForm.Threshold instanceof Array
            "
          >
            <el-row>
              <el-col :lg="12" :md="24" :sm="24" :xs="24" class="mar-btm-10">
                <span class="pull-left mar-rgt-10">下限值：</span>
                <el-input-number
                  :min="0"
                  v-model="triggerForm.Threshold[0]"
                  class="pull-left mar-rgt-10"
                  style="width: 150px"
                ></el-input-number>
              </el-col>
              <el-col :lg="12" :md="24" :sm="24" :xs="24">
                <span class="pull-left mar-rgt-10">上限值：</span>
                <el-input-number
                  :min="0"
                  v-model="triggerForm.Threshold[1]"
                  class="pull-left"
                  style="width: 150px"
                ></el-input-number>
              </el-col>
            </el-row>
          </div>
          <div v-else>
            <el-input-number
              :min="triggerForm.Type === 11 ? 0 : -9999999"
              v-model="triggerForm.Threshold"
              class="pull-left"
            ></el-input-number>
            <div
              v-if="triggerForm.Type === 11"
              class="pull-left mar-lft"
              style="
                font-size: 10px;
                color: #758697;
                display: inline-block;
                line-height: 30px;
                padding-left: 5px;
              "
            >
              延迟触发秒数，延迟时间内重新上线将不会发送掉线报警
            </div>
          </div>
        </el-form-item>
        <el-form-item label="通知方式" prop="Inform">
          <el-select
            style="width: 100%"
            v-model="triggerForm.Inform"
            placeholder="请选择通知方式"
          >
            <el-option
              v-for="inform in informList"
              :label="inform.Value"
              :value="inform.Key"
              :key="inform.Key"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="通知对象" v-if="triggerForm.Inform !== 0">
          <el-input
            :class="{
              'mar-btm':
                triggerForm.Targets.length > 1 &&
                index !== triggerForm.Targets.length - 1,
            }"
            v-for="(item, index) in triggerForm.Targets"
            v-model="triggerForm.Targets[index]"
            :key="index"
            :placeholder="targetPlaceholder"
          >
            <i
              v-if="index === triggerForm.Targets.length - 1"
              slot="append"
              class="fa fa-plus-circle cur-pointer"
              style="
                font-size: 18px;
                position: relative;
                top: 1px;
                color: #86c042;
              "
              @click="triggerForm.Targets.push('')"
            ></i>
            <i
              v-if="triggerForm.Targets.length > 1"
              slot="append"
              class="fa fa-minus-circle mar-lft cur-pointer"
              style="
                font-size: 18px;
                position: relative;
                top: 1px;
                color: #ee4a47;
                padding-left: 10px;
              "
              @click="triggerForm.Targets.splice(index, 1)"
            ></i>
          </el-input>
        </el-form-item>
        <el-form-item label="触发频率" prop="Frequency">
          <el-input-number
            :min="1"
            :max="65535"
            v-model="triggerForm.Frequency"
            class="mar-rgt"
          ></el-input-number>
          <div style="font-size: 13px; color: #758697; line-height: 30px">
            该触发器在同一个设备上最小触发间隔(分钟)
          </div>
        </el-form-item>
        <el-form-item label="静默时间" class="mar-no">
          <el-input v-model="triggerForm.Slient"></el-input>
          <div style="font-size: 13px; color: #758697; line-height: 30px">
            静默时间以逗号分割，格式为00:00-08:00,18:00-23:59
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" :disabled="canSubmit" @click="isDoAction"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <el-dialog
      title="选择产品"
      :visible.sync="productVisible"
      append-to-body
      :close-on-click-modal="false"
      @close="closeProduct"
      width="60%"
      top="5vh"
    >
      <div class="top">
        <div class="left">
          <el-button type="success" @click="onChooseProducts">
            <i class="far fa-fw fa-save" aria-hidden="true"></i> 选 择
          </el-button>
        </div>
        <div class="right">
          <select2
            labelName="NameNumber"
            v-model="former.DciProductModelID"
            url="dci/model/product/list?order=name"
            clearable
            placeholder="选择产品型号"
            no-data-text="没有产品型号"
            :urlParams="{
              where: {},
            }"
            q="NameNumber:like"
            :qinwhere="true"
            :queryOne="false"
          ></select2
          >&nbsp;
          <el-input
            v-model.trim="former['SN:like']"
            placeholder="输入SN"
            @keydown.enter.native="onProductSubmitQuery"
            style="width: 200px"
          >
          </el-input
          >&nbsp;
          <el-button type="primary" @click="onProductSubmitQuery">
            <i class="fas fa-fw fa-search"></i>
          </el-button>
        </div>
      </div>

      <el-table
        :data="itemList"
        v-loading="loading"
        @selection-change="onSelectChanged"
        :row-key="getRowKey"
        ref="tableProducts"
      >
        <el-table-column
          type="selection"
          width="55"
          :reserve-selection="true"
        ></el-table-column>
        <el-table-column prop="DciProductModel.Name" label="产品型号名称" />
        <el-table-column prop="SN" label="产品SN">
          <template slot-scope="{ row }">
            <el-tag>
              {{ row.SN }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
          prop="DciPvProductVersion.PvName"
          label="文件系统版本"
        />
        <el-table-column prop="StatusName" label="状态" width="80" />
      </el-table>

      <div class="clearfix mar-top-10">
        <el-pagination
          class="pull-right"
          @current-change="onProductChangePage"
          layout="total, prev, pager, next"
          :total="productPager.total"
          :current-page="productPager.page"
          :page-size="productPager.size"
        >
        </el-pagination>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import {
  find as _find,
  findIndex as _findIndex,
  cloneDeep as _cloneDeep,
} from "lodash";
import Vue from "vue";
// import SelectClientDialog from "@/components/SelectClientDialog";

// 自定义autoComplete列表
Vue.component("my-keypath-list", {
  functional: true,
  render: (h, ctx) => {
    const item = ctx.props.item;
    return h("li", ctx.data, [
      h("span", { attrs: { class: "keypathName pull-left" } }, [
        `${item.Keypath} (${item.Name})`,
      ]),
      h("span", { attrs: { class: "categoryName pull-right" } }, [
        item.CategoryName,
      ]),
    ]);
  },
  props: {
    item: { type: Object, required: true },
  },
});
export default {
  components: {
    // SelectClientDialog,
  },
  mounted() {
    this.getTriggerList(); //触发器设置列表
    this.getClientList(); //客户端范围
    this.getTagList(); //标签
    this.getModelList(); //产品型号
    this.getCategories(); //获取数据集设置列表
    this.getInformList(); //获取通知方式列表
    this.getTypeList(); //获取触发类型列表
  },
  data() {
    return {
      clientList: [], //客户端范围
      tagList: [], //标签
      modelList: [], //产品型号名称
      typeList: [], //触发类型
      informList: [], //通知方式
      isWatchClient: true,
      Keypath: "",
      // 是否触发对triggerForm中type的监听，弹出编辑框时为false避免再次更改
      isWatchType: true,
      // 通知对象的正则名
      targetValidatorName: "",
      // 通知对象的正则
      phoneRegObj: {
        reg: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
        msg: "手机号格式不正确",
      },
      emailRegObj: {
        reg: /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/,
        msg: "邮箱格式不正确",
      },
      requestRegObj: {
        reg: /(http|ftp|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?/, // eslint-disable-line
        msg: "URL格式不正确",
      },
      // TriggerTypeOptions: [
      //   { label: ">", value: "GT" },
      //   { label: ">=", value: "GTE" },
      //   { label: "<", value: "LT" },
      //   { label: "<=", value: "LTE" },
      //   { label: "=", value: "EQ" },
      //   { label: "!=", value: "NE" },
      //   { label: "范围内", value: "IN" },
      //   { label: "范围外", value: "NOTIN" },
      //   { label: "存在", value: "EXISTS" },
      //   { label: "不存在", value: "NOTEXISTS" },
      //   { label: "掉线", value: "OFFLINE" },
      // ],
      triggerRule: {
        Name: [
          {
            required: true,
            message: "触发器名称必填",
            trigger: "blur, change",
          },
        ],
        Client: [
          {
            required: true,
            message: "客户端范围必选",
            trigger: "blur, change",
          },
        ],
        Keypath: [
          { required: true, message: "数据路径必选", trigger: "blur, change" },
        ],
        Type: [
          { required: true, message: "触发类型必选", trigger: "blur, change" },
        ],
        Threshold: [
          { required: true, message: "触发阈值必填", trigger: "blur, change" },
        ],
        Inform: [
          { required: true, message: "通知方式必选", trigger: "blur, change" },
        ],
        Frequency: [
          { required: true, message: "触发频率必填", trigger: "blur, change" },
        ],
      },
      triggerForm: {
        ID: 0,
        Name: "", //名称
        Client: 0, //客户端范围（0：全应用，1：产品，2：标签，3：产品型号名称）
        ClientProps: { ID: [], Tag: [], ModuleID: [] }, //客户端范围具体内容 :  {ID: [], Tag: [], ModuleID: []}
        StreamID: 0, //数据流ID
        Keypath: "", //数据路径
        Taxo: "", //数据集编号
        Type: "", //触发类型(1:>,2:>=,3:<,4:<=,5:=,6:!=,7:范围内,8:范围外,9:存在,10:不存在,11:掉线)
        Threshold: "", //触发阈值
        Inform: 0, //通知方式(0:无需通知,1:钉钉通知,2:邮箱通知,3:网页通知)
        Targets: [""], //通知对象json
        Slient: "", //静默时间(逗号分割，格式为00:00-08:00,18:00-23:59)
        Frequency: 60, //触发频率,默认60分钟
      },
      isEdit: false,
      dialogVisible: false,
      form: {
        Name: "",
        Keypath: "",
      },
      triggerList: [],
      triggerTotal: 0,
      triggerPage: 1,
      timeout: "",
      // 控制确认按钮的disable属性
      submitDisable: false,
      appCategories: [], //数据集列表
      //======弹框--选择产品==========
      //查询功能
      former: {
        DciProductModelID: "",
        "SN:like": "",
      },
      itemList: [],
      loading: false,
      productPager: {
        total: 0,
        page: 1,
        size: 10,
      },
      productVisible: false,
      options: [], //弹框选择的产品
      currentProducts: [], //下拉框绑定值
    };
  },
  computed: {
    targetPlaceholder() {
      //通知方式(0:无需通知,1:钉钉通知,2:邮箱通知,3:网页通知)
      if (this.triggerForm.Inform === 1) {
        return "请填写通知对象的手机号";
      } else if (this.triggerForm.Inform === 2) {
        return "请填写通知对象的邮箱";
      } else if (this.triggerForm.Inform === 3) {
        return "请填写通知对象的网址";
      }
      return "根据通知方式填写对应的通知对象";
    },
    triggerFormInform() {
      return this.triggerForm.Inform;
    },
    triggerFormType() {
      return this.triggerForm.Type;
    },
    // 根据数据集数组遍历出需要的包含stream_id, taxo, keypath等信息
    categories() {
      const array = [];
      const categories = [];
      this.appCategories.forEach((categoryItem) => {
        if (categoryItem.Streams && categoryItem.Streams.length >= 1) {
          array.push([]);
          categoryItem.Streams.forEach((streamItem) => {
            array[array.length - 1].push({
              value: streamItem.Keypath,
              Name: streamItem.Name,
              Taxo: categoryItem.Taxo,
              CategoryName: categoryItem.Name,
              Keypath: streamItem.Keypath,
              StreamID: streamItem.ID,
            });
          });
        }
      });
      array.forEach((array) => {
        array.forEach((obj) => {
          categories.push(obj);
        });
      });
      return categories;
    },
    canSubmit() {
      return this.submitDisable;
    },
  },
  watch: {
    // 触发类型改变时阈值的改变
    triggerFormType() {
      //触发类型(1:>,2:>=,3:<,4:<=,5:=,6:!=,7:范围内,8:范围外,9:存在,10:不存在,11:掉线)
      if (this.isWatchType) {
        if (this.triggerFormType === 7 || this.triggerFormType === 8) {
          this.triggerForm.Threshold = [];
          this.triggerForm.Threshold.push(0, 1);
        } else if (this.triggerFormType === 9 || this.triggerFormType === 10) {
          this.triggerForm.Threshold = "";
        } else {
          this.triggerForm.Threshold = 0;
        }
      }
    },
    // 通知方式改变时正则改变
    triggerFormInform() {
      //通知方式(0:无需通知,1:钉钉通知,2:邮箱通知,3:网页通知)
      if (this.triggerFormInform === 1) {
        this.targetValidatorName = "phoneRegObj";
      } else if (this.triggerFormInform === 2) {
        this.targetValidatorName = "emailRegObj";
      } else if (this.triggerFormInform === 3) {
        this.targetValidatorName = "requestRegObj";
      } else {
        this.triggerForm.Targets = [""];
      }
    },
  },
  methods: {
    //获取客户端范围列表
    getClientList() {
      this.$axios.get("dci/trigger/client-list").then(
        (resp) => {
          this.clientList = resp.data.data;
        },
        (resp) => {
          this.$sys.alarmResponse(resp);
        }
      );
    },
    //获取标签列表
    getTagList() {
      this.$axios
        .get("dci/station/tag")
        .then((response) => {
          this.tagList = response.data;
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {});
    },
    //获取产品型号名称列表
    getModelList() {
      this.$axios.get("dci/model/product/list?order=name").then(
        (resp) => {
          this.modelList = resp.data.data;
          // this.modelList.push({
          //   ID:0,
          //   NameNumber:"其它类型",
          // })
        },
        (resp) => {
          this.$sys.alarmResponse(resp);
        }
      );
    },
    //获取触发类型列表
    getTypeList() {
      this.$axios.get("dci/trigger/type-list").then(
        (resp) => {
          this.typeList = resp.data.data;
        },
        (resp) => {
          this.$sys.alarmResponse(resp);
        }
      );
    },
    //获取通知方式列表
    getInformList() {
      this.$axios.get("dci/trigger/inform-list").then(
        (resp) => {
          this.informList = resp.data.data;
        },
        (resp) => {
          this.$sys.alarmResponse(resp);
        }
      );
    },
    //获取数据集设置列表
    getCategories() {
      this.$axios.get("category", { params: { with: ["Streams"] } }).then(
        (response) => {
          this.appCategories = response.data.data;
        },
        (response) => {
          this.$sys.alarmResponse(response);
        }
      );
    },

    //点击新增触发器按钮
    showAddDialog() {
      this.isEdit = false;
      this.dialogVisible = true;
    },

    //点击编辑触发器按钮
    showEditDialog(item) {
      // 防止触发类型变化时，将数据变为默认数值
      this.$nextTick(() => {
        this.isWatchType = false;
      });
      this.isWatchClient = false;
      const clientInfo = _cloneDeep(item);
      // 当触发类型为范围时，把获取到的阈值字符串更改为数组
      if (clientInfo.Threshold.indexOf(",") > 0) {
        clientInfo.Threshold = clientInfo.Threshold.split(",").map((item) =>
          parseInt(item, 10)
        );
      }
      if (clientInfo.Keypath) {
        const resultObj = _find(this.categories, {
          Keypath: clientInfo.Keypath,
        });
        if (resultObj) {
          this.Keypath = resultObj.Keypath;
        } else {
          this.Keypath = "";
        }
      }

      // 初始化绑定产品
      if (clientInfo.Client === 1 && clientInfo.ClientProps.ID.length > 0) {
        this.$axios
          .get(`dci/product/stock-list/list?idsIn=${clientInfo.ClientProps.ID}`)
          .then((response) => {
            this.currentProducts = [];
            for (let i = 0; i < response.data.data.length; i++) {
              let obj1 = response.data.data[i];
              this.currentProducts.push({
                ID: obj1.ID,
                SN: obj1.SN,
              });
            }
          })
          .catch(({ response }) => {
            this.$sys.alarmResponse(response);
          });
      }

      this.triggerForm = { ...this.triggerForm, ...clientInfo };
      this.isEdit = true;
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.isWatchType = true;
      });
    },
    //删除触发器
    showDelete(id) {
      this.$confirm("此操作将删除该触发器, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.doAction(id);
        })
        .catch(() => {});
    },

    // 增删改方法
    doAction(item) {
      if (typeof item === "object") {
        this.submitDisable = true;
        item.Threshold = `${item.Threshold}`; //数据库是字符串

        if (this.isEdit) {
          this.$axios.put(`dci/trigger/${item.ID}`, item).then(
            () => {
              this.$message({
                type: "success",
                message: "成功修改触发器",
                duration: 1500,
              });
              this.getTriggerList();
              this.cancel();
              this.submitDisable = false;
            },
            (resp) => {
              this.submitDisable = false;
              this.$sys.alarmResponse(resp);
            }
          );
        } else {
          this.$axios.post("dci/trigger", item).then(
            () => {
              this.$message({
                type: "success",
                message: "成功新增触发器",
                duration: 1500,
              });
              this.getTriggerList();
              this.cancel();
              this.submitDisable = false;
            },
            (resp) => {
              this.submitDisable = false;
              this.$sys.alarmResponse(resp);
            }
          );
        }
      } else {
        this.$axios.delete(`dci/trigger/${item}`).then(
          () => {
            this.$message({
              type: "success",
              message: "成功删除触发器",
              duration: 1500,
            });
            this.getTriggerList();
          },
          (resp) => {
            this.$sys.alarmResponse(resp);
          }
        );
      }
    },

    //过滤数据路径
    queryKeypath(q, cb) {
      this.$refs.keypathInput.isFocus = true;
      clearTimeout(this.timeout);
      let results = [];
      results = this.categories.filter(
        (item) => item.Name.includes(q) || item.Keypath.includes(q)
      );
      this.timeout = setTimeout(() => {
        cb(results);
      }, 300);
    },
    //选择数据路径
    selectKeypath(item) {
      this.triggerForm.Keypath = item.Keypath;
      this.triggerForm.StreamID = item.StreamID;
      this.triggerForm.Taxo = item.Taxo;
      this.$refs.triggerForm.validateField("Keypath");
    },

    changeClient() {
      if (this.isWatchClient) {
        this.triggerForm.ClientProps = { ID: [], Tag: [], ModuleID: [] };
        // this.$refs.selectClientDialog.selection = [];
      } else {
        this.isWatchClient = true;
      }
    },

    returnTypeName(type) {
      const obj = _find(this.TriggerTypeOptions, { value: type });
      if (obj) {
        return obj.label;
      }
      return "-";
    },
    returnKeypathName(Keypath) {
      const obj = _find(this.categories, { Keypath });
      if (obj) {
        return obj.Name;
      }
      return "-";
    },
    // 当选择范围内或范围外时对下限值和上限值的验证
    thresholdValidator() {
      if (this.triggerForm.Threshold[1] < this.triggerForm.Threshold[0]) {
        this.$message({
          type: "warning",
          message: "上限值必须大于下限值",
          duration: 1500,
        });
        return false;
      }
      return true;
    },
    // 对通知对象的验证
    targetValidator(objName) {
      if (objName != "") {
        const errorMsg = this[objName].msg;
        const array = [];
        this.triggerForm.Targets.forEach((item, index) => {
          if (!this[objName].reg.test(item)) {
            array.push(index);
          }
        });
        if (array.length > 0) {
          this.$message({
            type: "warning",
            message: `${
              array.length === 0
                ? "选择通知方式后通知对象必填"
                : `通知对象中第${array
                    .map((item) => item + 1)
                    .join(" ")}个${errorMsg}`
            }`,
          });
          return false;
        }
        return true;
      } else {
        return true;
      }
    },
    clientPropsValidator() {
      //客户端范围（0：全应用，1：产品，2：标签，3：产品型号名称）
      if (this.triggerForm.Client === "id") {
        if (this.triggerForm.ClientProps.ID.length === 0) {
          this.$message({
            type: "warning",
            message: "必选选择一个以上的产品",
            duration: 1500,
          });
          return false;
        }
      } else if (this.triggerForm.Client === 2) {
        if (this.triggerForm.ClientProps.Tag.length === 0) {
          this.$message({
            type: "warning",
            message: "标签为必选项",
            duration: 1500,
          });
          return false;
        }
      } else if (this.triggerForm.Client === 3) {
        if (this.triggerForm.ClientProps.ModuleID.length === 0) {
          this.$message({
            type: "warning",
            message: "产品型号名称为必选项",
            duration: 1500,
          });
          return false;
        }
      }
      return true;
    },
    isDoAction() {
      this.$refs.triggerForm.validate((valid) => {
        if (valid) {
          let isDo = true;
          const triggerForm = _cloneDeep(this.triggerForm);
          // 触发类型为掉线时，数据路径不上传
          if (triggerForm.Type === 11) {
            triggerForm.Keypath = "";
            triggerForm.Taxo = "";
            triggerForm.StreamID = 0;
          }
          // 若需要通知，验证通知对象
          if (triggerForm.Inform !== 0) {
            if (!this.targetValidator(this.targetValidatorName)) {
              isDo = false;
            }
          }
          if (this.triggerForm.Threshold instanceof Array) {
            if (this.thresholdValidator()) {
              triggerForm.Threshold = triggerForm.Threshold.join(",");
            } else {
              isDo = false;
            }
          }
          if (!this.clientPropsValidator()) {
            isDo = false;
          }
          if (isDo) {
            this.doAction(triggerForm);
          }
        }
      });
    },
    cancel() {
      this.$refs.triggerForm.resetFields();
      // this.$refs.selectClientDialog.clear();
      this.triggerForm = {
        ID: 0,
        Name: "", //名称
        Client: 0, //客户端范围（0：全应用，1：产品，2：标签，3：产品型号名称）
        ClientProps: { ID: [], Tag: [], ModuleID: [] }, //客户端范围具体内容 :  {ID: [], Tag: [], ModuleID: []}
        StreamID: 0, //数据流ID
        Keypath: "", //数据路径
        Taxo: "", //数据集编号
        Type: "", //触发类型(1:>,2:>=,3:<,4:<=,5:=,6:!=,7:范围内,8:范围外,9:存在,10:不存在,11:掉线)
        Threshold: "", //触发阈值
        Inform: 0, //通知方式(0:无需通知,1:钉钉通知,2:邮箱通知,3:网页通知)
        Targets: [""], //通知对象json
        Slient: "", //静默时间(逗号分割，格式为00:00-08:00,18:00-23:59)
        Frequency: 60, //触发频率,默认60分钟
      };
      this.Keypath = "";
      this.dialogVisible = false;
      this.currentProducts = [];
    },

    changeTriggerPage(page) {
      this.triggerPage = page;
      this.getTriggerList();
    },
    submitQuery() {
      if (this.triggerPage === 1) {
        this.getTriggerList();
      } else {
        this.triggerPage = 1;
      }
    },
    onSubmitQuery() {
      this.triggerPage = 1;
      this.getTriggerList();
    },
    getTriggerList() {
      this.$axios
        .get("dci/trigger", {
          params: {
            where: {
              "Name:like": this.form.Name,
              "Keypath:like": this.form.Keypath,
            },
            page: this.triggerPage,
            with: ["Stream.Category"],
          },
        })
        .then(
          (resp) => {
            this.triggerList = resp.data.data;
            this.triggerTotal = resp.data.total;
          },
          (resp) => {
            this.$sys.alarmResponse(resp);
          }
        );
    },

    //===============弹框-选择产品==========================

    //点击选择产品按钮
    onChooseProductsClick() {
      this.getProductItemList();
      this.options = [];
      this.productVisible = true;
    },

    //点击查询产品列表
    onProductSubmitQuery() {
      this.productPager.page = 1;
      this.getProductItemList();
    },

    onProductChangePage(page) {
      this.productPager.page = page;
      this.getProductItemList();
    },

    //获取产品列表
    getProductItemList() {
      this.loading = true;
      this.$axios
        .get("dci/product/stock-list/list", {
          params: {
            where: {
              DciProductModelID: this.former.DciProductModelID,
              "SN:like": this.former["SN:like"],
            },
            ...this.productPager,
            with: [
              "DciProductModel",
              "DciAccessories.DciAccessoryModel",
              "DciPvProductVersion",
            ],
            order: ["-stockin_at", "-sn"],
          },
        })
        .then((response) => {
          this.itemList = response.data.data;
          this.productPager = _.pick(response.data, "size", "page", "total");
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    //选择产品
    onSelectChanged(options) {
      this.options = options;
    },

    //弹框选择产品
    onChooseProducts() {
      let obj1;
      let objID2;
      for (obj1 of this.options) {
        let flag = true;
        for (objID2 of this.triggerForm.ClientProps.ID) {
          if (obj1.ID === objID2) {
            flag = false;
            break;
          }
        }
        if (flag) {
          this.triggerForm.ClientProps.ID.push(obj1.ID);
        }
      }
      this.$axios
        .get(`dci/product/stock-list/list?idsIn=${this.triggerForm.ClientProps.ID}`)
        .then((response) => {
          this.currentProducts = [];
          for (let i = 0; i < response.data.data.length; i++) {
            let obj1 = response.data.data[i];
            this.currentProducts.push({
              ID: obj1.ID,
              SN: obj1.SN,
            });
          }
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        });

      this.closeProduct();
    },
    getRowKey(row) {
      return row.ID;
    },
    closeProduct() {
      this.options = [];
      this.$refs.tableProducts.clearSelection();
      this.former.DciProductModelID = "";
      this.former["SN:like"] = "";
      this.productVisible = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.my-autocomplete li {
  line-height: normal;
  padding: 7px;
}
.my-autocomplete li .keypathName {
  text-overflow: ellipsis;
  overflow: hidden;
}
.my-autocomplete li .categoryName {
  font-size: 13px;
  color: #b4b4b4;
}
.my-autocomplete li .highlighted .categoryName {
  color: #ddd;
}
.hideSuggestion {
  display: none;
}

.top {
  text-align: right;
  background-color: #f5f7fa;
  height: 30px;
  padding: 10px 20px 10px 20px;
  margin: -30px -20px 10px -20px;
}
.left {
  float: left;
  text-align: left;
  width: 20%;
}
.right {
  float: right;
  text-align: right;
  width: 80%;
}
</style>
